import { Performer } from '../../core/performer'
import { HttpMethod } from '../../core/types'

export class GetNudgedChatters extends Performer<void, Array<{ id: number }>> {
  protected method = HttpMethod.GET
  protected url = '/nudge/chatters'
}

export default new GetNudgedChatters().perform
